export default __webpack_public_path__ + "static/media/battery_1.b41127aa.png";